import { useEffect, useState } from 'react';
import { BRAND_PRESETS, setBrand, setTheme, useAppearance } from '../lib/appearance.ts';
import { ColorOptions, swatchStyle } from './ColorMenu.tsx';

/**
 * Farbwahl und Hell/Dunkel in der Kopfleiste. Beides gilt nur fuer diesen
 * Browser -- siehe lib/appearance.ts.
 */
export function AppearanceControls() {
  const { brand, brandId, theme } = useAppearance();
  const [open, setOpen] = useState(false);
  const current = BRAND_PRESETS.find((p) => p.id === brandId);
  const dark = theme === 'dark';

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <div className="appearance">
      <button
        type="button"
        className="appearance__btn appearance__btn--color"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={`Farbe wählen, gerade ${current?.label ?? 'eigene Farbe'}`}
        title="Farbe wählen"
      >
        <span className="swatch" style={swatchStyle(brand)} />
        <span className="appearance__label">{current?.label ?? 'Eigene'}</span>
        <svg className="appearance__chev" width="10" height="10" viewBox="0 0 10 10" aria-hidden>
          <path d="M2 3.5 5 6.5l3-3" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>

      <button
        type="button"
        className="appearance__btn appearance__btn--icon"
        onClick={() => setTheme(dark ? 'light' : 'dark')}
        aria-label={dark ? 'Helles Design einschalten' : 'Dunkles Design einschalten'}
        title={dark ? 'Hell' : 'Dunkel'}
      >
        {dark ? (
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden>
            <circle cx="8" cy="8" r="3.2" fill="currentColor" />
            <path
              d="M8 1.2v1.6M8 13.2v1.6M1.2 8h1.6M13.2 8h1.6M3.2 3.2l1.1 1.1M11.7 11.7l1.1 1.1M3.2 12.8l1.1-1.1M11.7 4.3l1.1-1.1"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden>
            <path d="M13.6 10.1A6 6 0 0 1 5.9 2.4a6 6 0 1 0 7.7 7.7Z" fill="currentColor" />
          </svg>
        )}
      </button>

      {open && (
        <>
          <button type="button" className="account__scrim" aria-label="Schließen" onClick={() => setOpen(false)} />
          <div className="appearance__menu" role="menu" aria-label="Farbe">
            {/* Das Farbfeld bleibt offen, solange man zieht -- jede Aenderung
                ist sofort auf der Seite zu sehen. */}
            <ColorOptions
              title="Farbe"
              value={brand}
              onPick={(hex) => {
                if (hex) setBrand(hex);
                setOpen(false);
              }}
              onCustom={setBrand}
            />
          </div>
        </>
      )}
    </div>
  );
}
